import { Button } from '../../ui/Button';
import { shell } from '../../copy/shell';

/**
 * Retry, beside a read that failed.
 *
 * The error it stands in goes the moment the read starts again, and the button with it; a
 * refresh notice goes once the read lands. Left on the button, focus would fall to <body>
 * either way, and a keyboard or screen reader user would start again from the top. So the
 * click moves focus first: to the page's h1 where the page gives it tabIndex -1, otherwise
 * to <main>, as a navigation does. Nothing is inert at that moment, so the focus lands.
 */
export function RetryButton({ onRetry }: { onRetry: () => void }) {
  return (
    <Button
      variant="secondary"
      size="sm"
      onClick={(e) => {
        focusPageTop(e.currentTarget);
        onRetry();
      }}
    >
      {shell.retry}
    </Button>
  );
}

function focusPageTop(from: HTMLElement): void {
  const main = from.closest('main');
  const h1 = (main ?? document).querySelector('h1');
  const target = h1?.hasAttribute('tabindex') ? h1 : main?.hasAttribute('tabindex') ? main : null;
  target?.focus({ preventScroll: true });
}
